module.exports = __webpack_public_path__ + "img/most_logo.df9b21d4.png";